<template>
    <div>
        <vue-toast ref='toast'></vue-toast>
    </div>
</template>

<script>
    import vueToast from 'vue-toast';
    import { mainEventBus } from '../../main';
    import { translationMixin } from '../mixins/translationMixin.js'
    var resetTimeout;
    export default {
        props:['data'],
        mixins: [translationMixin],
        components: {
            vueToast: vueToast
        },
        created: function() {
            console.log('toast created');
            let that = this;
            mainEventBus.$on('alert', function (data) {
//               console.log("mesages arr",that.messagesArray);
//               console.log("DATA",data);
               if(that.previousMessage != data.msg) {
                  that.showAlert(data);
                  that.previousMessage = data.msg;
                  clearTimeout(resetTimeout);
                  resetTimeout = setTimeout(function(){
                     that.previousMessage = '';
                  }, that.timeLife);
               }
            })
        },
        data: function(){
            return {
               previousMessage: '',
//                data: {
//                    type: String,  // info warning error success
//                    msg: String
//                },
                // toast
                message: '',
                maxToasts: 4,
                position: 'top right',
                theme: 'error', // info warning error success
                timeLife: 5000,
                closeBtn: false,
                messagesArray:[]
            }
        },
        sockets: {
            message: function(data){

                console.log('message toast');

               let that = this;

               if(that.previousMessage != data.msg && !(this.checkIfInArray(this.messagesArray,data.msg))) {
                   this.messagesArray.push(data.msg);
                  that.showAlert(data);
                  that.previousMessage = data.msg;
                  clearTimeout(resetTimeout);
                  resetTimeout = setTimeout(function(){
                     that.previousMessage = '';
                     if(that.messagesArray){
                         that.messagesArray.splice(0,that.messagesArray.length);
                     }
                  }, that.timeLife);
               }


            }
        },
        methods: {
            showAlert: function(data){
                this.message = (data) ? data.msg : this.data.msg;
                this.theme = (data) ? data.type : this.data.type;
                if(this.translations[this.message]){
                    this.message = this.translations[this.message];
                }
                const toast = this.$refs.toast;
                if(!toast){
//                    alert(this.message);
                    return false;
                }
                toast.setOptions({
                    position: this.position,
                    maxToasts: this.maxToasts
                });
                let icon = "";
                switch (this.theme) {
                    case 'info':
                      icon = '<i class="fa fa-info-circle" aria-hidden="true"></i>';
                      break;
                    case 'warning':
                      icon = '<i class="fa fa-warning" aria-hidden="true"></i>';
                      break;
                    case 'error':
                      icon = '<i class="fa fa-times-circle" aria-hidden="true"></i>';
                      break;
                    case 'success':
                      icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';
                      break;
                    default:
                        icon = '<i class="fa fa-info-circle" aria-hidden="true"></i>';
                        break;
                }
                this.message = icon + " " + this.message;
                toast.showToast(this.message, {
                    theme: this.theme,
                    timeLife: this.timeLife,
                    closeBtn: this.closeBtn
                });

            },
            checkIfInArray(arr,item){
                return arr.includes(item);
            }
        }
    }
</script>

<style>
    .vue-toast_message {
        padding: 5px 22px 5px 10px;
        color: white;
        font-family: inherit;
        margin-left: -5px;
    }

    .vue-toast-manager_container {
        z-index: 1000;
    }
    .vue-toast-manager_container.\--top {
        top: 30px;
    }
    .vue-toast-manager_container.\--bottom {
        bottom: 10px;
    }
    .vue-toast-manager_container.\--left {
        left: 0px;
    }
    .vue-toast-manager_container.\--right {
        right: 0px;
    }
    .vue-toast-manager_toasts {
        position: relative;
    }

    /*.vue-toast_container._default .vue-toast_message {*/
        /*background-color: rgba(0,0,0, .9);*/
    /*}*/
    /*.vue-toast_container._info .vue-toast_message {*/
        /*background-color: rgba(49,112,143, .9);*/
    /*}*/
    /*.vue-toast_container._success .vue-toast_message {*/
        /*background-color: rgba(158,172,142, .9);*/
    /*}*/
    /*.vue-toast_container._warning .vue-toast_message {*/
        /*background-color: rgba(138,109,59, .9);*/
    /*}*/
    /*.vue-toast_container._error .vue-toast_message {*/
        /*background-color: rgba(231,76,60, .9);*/
    /*}*/
</style>


// WEBPACK FOOTER //
// ToastAlert.vue?40fb56d3